import { Alert } from '@/ui'

interface ImpersonationNoticeProps {
  message?: string
}

export const ImpersonationNotice = ({
  message = 'Banking is not available in admin view.',
}: ImpersonationNoticeProps) => (
  <Alert variant="warning" description={message} />
)
